import React from 'react';

import { Page } from 'ha/modules/Page';
import { useRequiredHermes } from 'ha/modules/Hermes';
import { defaultFont } from 'ha/constants/fonts/default';
import { sourceSansHeaders as sharpSansHeadersFont } from 'ha/constants/fonts/sourceSansHeaders';
import { BlogPageLayout } from '../components/BlogPageLayout';
import { HermesData } from '../types';
import { getBlogCategory } from '../utils/getBlogCategory';

export const BlogPage: React.FC = () => {
  const { data } = useRequiredHermes<HermesData>();

  const category = getBlogCategory(data.blogType);
  const { analyticsCampaign, city, country, topicCluster } = data;
  const cityCanonical = city && city.canonical;
  const countryCode = country && country.canonical;

  return (
    <Page
      name={data.compactTitle || data.title}
      category={category}
      activeFonts={[defaultFont, sharpSansHeadersFont]}
      hideIntercom
      traits={{ cityCanonical, countryCode, analyticsCampaign, topicCluster }}
    >
      <BlogPageLayout />
    </Page>
  );
};
